import {Injectable} from '@angular/core';
import {GlobalService} from '../../service/global.service';
import {Router} from '@angular/router';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public globalService: GlobalService, private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.router.url != '/' && !(this.router.url.indexOf('/login') > -1)) {
            if (this.globalService.usuario == null || this.globalService.usuario.access_token == undefined || !this.globalService.setCookieUsuarioLogado()) {
                this.globalService.abrirModalLogin();
            }
        }
        if (request.headers.get('Authorization') == null) {
            if (this.globalService.usuario != null) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${this.globalService.usuario.access_token}`
                    }
                });
            }
        }
        return next.handle(request);
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/token-interceptor.ts